import { safeReload } from '@/utils/safeReload';

export function registerServiceWorker() {
  // Never register SW in native Capacitor context
  if ((window as any).Capacitor?.isNativePlatform?.()) return;

  if ('serviceWorker' in navigator) {
    window.addEventListener('load', async () => {
      try {
        // Unregister any existing service workers first to force fresh install
        const existingRegistrations = await navigator.serviceWorker.getRegistrations();
        await Promise.all(existingRegistrations.map(reg => reg.unregister()));
        if (import.meta.env.DEV) console.log('[SW Client] Unregistered old service workers');
        
        const registration = await navigator.serviceWorker.register('/sw.js');
        await navigator.serviceWorker.ready;
        if (import.meta.env.DEV) console.log('[SW Client] Service Worker registered:', registration);
        
        // Only listener: updatefound with debounced safe reload
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                if (import.meta.env.DEV) console.log('[SW Client] New service worker available, scheduling reload...');
                // Delay 2s to let SW stabilize, then safe reload
                setTimeout(() => safeReload(), 2000);
              }
            });
          }
        });
        
      } catch (err) {
        if (import.meta.env.DEV) console.error('[SW Client] Service Worker registration failed:', err);
      }
    });
  }
}
